import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";
import type {
  CperapportState,
  CpeRapportListState,
  singleElementState,
} from "@/types/store";

const cperapportListState: CpeRapportListState = {
  data: [],
  error: null,
  loading: false,
  count: 0,
};

const singleElementState: singleElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

export const cpeState: CperapportState = {
  cperapports: cperapportListState,
  cperapport: singleElementState,
};

export const CpeRapportModule = {
  namespaced: true,
  state: cpeState,
  actions,
  mutations,
  getters,
};
